import { render, staticRenderFns } from "./DeletePrices.vue?vue&type=template&id=02b5536e&scoped=true&"
import script from "./DeletePrices.vue?vue&type=script&lang=js&"
export * from "./DeletePrices.vue?vue&type=script&lang=js&"
import style0 from "./DeletePrices.vue?vue&type=style&index=0&id=02b5536e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b5536e",
  null
  
)

export default component.exports